import { GET_OFFER_LIST_QUERY } from '../graphql-client/queries';

const resolvers = {
  Mutation: {
    removeOfferClient: (_info, _args, { cache }) => {
      const offerData = cache.readQuery(
        { query: GET_OFFER_LIST_QUERY, variables: { ..._args.queryVars } },
      );
      const data = {
        offerList: {
          data: [...[], ...offerData.offerList.data.filter((el) => el._id !== _args.id)],
          count: offerData.offerList.count,
          hasNextData: offerData.offerList.hasNextData,
          __typename: offerData.offerList.__typename,
        },
      };
      cache.writeQuery({ query: GET_OFFER_LIST_QUERY, variables: { ..._args.queryVars }, data });
    },

    removePrivateOfferClient: (_info, _args, { cache }) => {
      const { status, artistId } = _args;
      const offerData = cache.readQuery(
        { query: GET_OFFER_LIST_QUERY, variables: { status, artistId } },
      );
      offerData.offerList.data = offerData.offerList.data.filter((el) => el._id !== _args.offerId);
      cache.writeQuery({ query: GET_OFFER_LIST_QUERY, variables: { status, artistId }, data: offerData });
    },

    updateRequestStatus: (_info, _args, { cache }) => {
      const offerData = cache.readQuery(
        { query: GET_OFFER_LIST_QUERY, variables: _args.apiData },
      );
      offerData.offerList.data = offerData.offerList.data.map((el) => {
        if (el._id === _args.offerId) {
          el.isRequested = _args.isRequested;
        }
        return el;
      });
      cache.writeQuery({ query: GET_OFFER_LIST_QUERY, variables: _args.apiData, data: offerData });
    },

    updateNotificationClient: (_info, _args, { cache }) => {
      const offerData = cache.readQuery(
        { query: GET_OFFER_LIST_QUERY, variables: _args.apiData },
      );
      offerData.offerList.data = offerData.offerList.data.map((el) => {
        if (el._id === _args.offerId && el.notification && el.notification.length > 0) {
          el.notification[0] = { isDetailRead: true };
        }
        return el;
      });
      cache.writeQuery({ query: GET_OFFER_LIST_QUERY, variables: _args.apiData, data: offerData });
    },

    updateContractAcceptedStatus: (_info, _args, { cache }) => {
      const offerData = cache.readQuery(
        { query: GET_OFFER_LIST_QUERY, variables: _args.apiData },
      );
      offerData.offerList.data = offerData.offerList.data.map((el) => {
        if (el._id === _args.offerId) {
          el.isContractAccepted = _args?.isContractAccepted;
        }
        return el;
      });
      cache.writeQuery({ query: GET_OFFER_LIST_QUERY, variables: _args.apiData, data: offerData });
    },
  },
};

export default { resolvers };
